import React from 'react';
import { Form } from './styled';
import { useLogin } from '../../../common/providers_services/LoginProvider';
import { IconInput } from '../../../shared/components/IconInput';
import { SignUpAgreements } from './SignUpAgreements';
import { FilledButton } from '../../../shared/styled-components/styled_buttons';

export const SocialLoginForm: React.FC = () => {
  const { formRef, userId, setUserId, name, setName, userIdError, agreements, setAgreements, submitSocialSignUp } = useLogin();

  const canSubmit = !!(agreements?.privacy && agreements?.terms);

  return (
    <Form ref={formRef} onSubmit={submitSocialSignUp}>
      <IconInput
        label={'아이디'}
        id={'login-inp'}
        value={userId}
        onChange={setUserId}
        placeholder={'이메일 주소 또는 연락처를 입력해주세요.'}
        style={{ width: '100%' }}
        required
        errorMessage={userIdError}
        autocomplete
      />
      <IconInput
        label={'이름'}
        value={name}
        onChange={setName}
        placeholder={'이름을 입력해주세요'}
        style={{ width: '100%' }}
        required
        autocomplete
      />
      <SignUpAgreements onToggle={setAgreements} style={{ marginTop: '1rem' }} />
      <FilledButton size={'s'} color={'primary'} style={{ width: '100%' }} disabled={!canSubmit}>
        회원가입
      </FilledButton>
    </Form>
  );
};
